import React from "react";
import { FiMenu } from "react-icons/fi";
import { useSidebar } from "../contexts/Sidebarcontext";
import logo from "../assets/logo.png"
import { useAtom } from "jotai";
import { userAtom, userTokenAtom } from "../atoms/globalStates";
import { useNavigate } from "react-router-dom";

const Navbar = ({ isAdmin,email="" }) => {
  const { toggle } = useSidebar();
  const [, setUserToken] = useAtom(userTokenAtom);
 const [, setUserData] = useAtom(userAtom);
 const navigate = useNavigate()
  
  
  const signOut = ()=>{
        setUserToken(null)
        setUserData(null)
        navigate("/login")
  }

  return (
    <header className="h-18 border-b bg-white/70 backdrop-blur flex items-center px-4 sticky top-0 z-50 w-full p-2 print:hidden">
      {/* Hamburger for < xl AND only for admins */}
      {isAdmin && (
        <>
         <div className='w-[140px] pl-[10px]'>
                <img className='w-[60px] h-[60px] print:hidden' src={logo} alt=""/> 
            </div>
      
       
        </>
        
      )}

    

      <div className="ml-auto flex items-center gap-3 text-gray-500">
               {email && <span className="">{email}</span>}
      </div>
      <div onClick={()=>signOut()} className="mx-2 flex items-center gap-3 text-blue-500 cursor-pointer">
              Sign Out
      </div>
        <button
          type="button"
          aria-label="Open menu"
          onClick={toggle}
          className="xl:hidden inline-flex items-center justify-center p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring focus:ring-blue-300"
        >
          <FiMenu size={20} />
        </button>
    </header>
  );
};

export default Navbar;
